import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Asset from 'src/app/model/asset';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCornerHomePageInpressWorkerControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as Asset;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };

    this.get = _get('/assets/profilePicture/', requestServices);
  }

  public profilePicture(emailAddress: string): Promise<Asset> {
    return this.get(emailAddress, this.deserialize).toPromise();
  }
}
